<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11 6.75a4.25 4.25 0 11-8.5 0 4.25 4.25 0 018.5 0zm.312 3.501a5.75 5.75 0 10-1.06 1.06l3.218 3.22a.75.75 0 101.06-1.061l-3.218-3.219z"
    fill="currentColor"
  />
</svg>
